export const thumbnailPlayBackgroundVar = '--video-thumbnail-play-background';
export const thumbnailPlayColorVar = '--video-thumbnail-play-color';
